export default __webpack_public_path__ + "static/media/empty-credentials.dc45254c.svg";